import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';
import { DadoDespesaDto } from '../../dtos/dado-despesa-dto';

@Injectable({
  providedIn: 'root',
})
export class DadoDespesaService {
  private apiUrl = `${environment.apiUrl}/despesa-educacao`;

  constructor(private caqRequestService: CaqRequestService) {}

  buscarPorMunicipio(codigoMunicipio: number, ano: number): Observable<DadoDespesaDto> {
    return this.caqRequestService
      .get<DadoDespesaDto>(`${this.apiUrl}/municipio/${codigoMunicipio}/${ano}`)
      .pipe(map((response) => response));
  }

  buscarPorPlanoEstadual(codigoEstado: number, ano: number): Observable<DadoDespesaDto> {
    return this.caqRequestService
      .get<DadoDespesaDto>(`${this.apiUrl}/estado/plano/${codigoEstado}/${ano}`)
      .pipe(map((response) => response));
  }

  buscarPorRedeEstadual(codigoEstado: number, ano: number): Observable<DadoDespesaDto> {
    return this.caqRequestService
      .get<DadoDespesaDto>(`${this.apiUrl}/estado/rede/${codigoEstado}/${ano}`)
      .pipe(map((response) => response));
  }

  buscarPorAno(ano: number): Observable<DadoDespesaDto> {
    return this.caqRequestService
      .get<DadoDespesaDto>(`${this.apiUrl}/${ano}`)
      .pipe(map((response) => response));
  }
}
